/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const MicStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M11.6226 20.077V23.4001M19.059 13.4308C19.059 15 17.9674 16.9297 16.597 18.1474C15.2266 19.3652 13.4569 20.0378 11.6236 20.0378C9.79029 20.0378 8.02068 19.3652 6.65023 18.1474C5.27979 16.9297 4.18823 15 4.18823 13.4308M11.6256 1.80005C13.9198 1.80005 15.7795 3.65979 15.7795 5.95389V12.6C15.7795 14.8942 13.9198 16.7539 11.6256 16.7539C9.33154 16.7539 7.4718 14.8942 7.4718 12.6V5.95389C7.4718 3.65979 9.33154 1.80005 11.6256 1.80005Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { MicStrokeIcon };
